module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "top": "20%",
      "left": "33%"
    }
  }, [_c('div', {
    staticClass: "form_modal"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('p', {
    staticClass: "form_title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkReceiverName && _vm.dirty.receiverName
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入收件人")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("收件人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.receiverName),
      expression: "param.receiverName"
    }],
    staticClass: "short",
    attrs: {
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.param.receiverName)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.receiverName = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "receiverName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkUserAdd && _vm.dirty.userAdd
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入收件人详细地址")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userAdd),
      expression: "param.userAdd"
    }],
    attrs: {
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.param.userAdd)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.userAdd = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userAdd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkUserPhone && _vm.dirty.userPhone
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入正确的电话号码")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userPhone),
      expression: "param.userPhone"
    }],
    staticClass: "short",
    staticStyle: {
      "width": "166px"
    },
    attrs: {
      "type": "number",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.param.userPhone)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.userPhone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.haveDefault),
      expression: "param.haveDefault"
    }],
    staticStyle: {
      "margin-left": "166px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.param.haveDefault) ? _vm._i(_vm.param.haveDefault, null) > -1 : (_vm.param.haveDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.param.haveDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.param, "haveDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.param, "haveDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.param, "haveDefault", $$c)
        }
      }
    }
  }), _vm._v("设为默认\n       ")]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [(_vm.type == 'add') ? _c('li', {
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.type == 'update') ? _c('li', {
    on: {
      "click": _vm.updateAddress
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8684f436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addAddress.vue
// module id = 868
// module chunks = 1